import { laptopMediumMax, mobileLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import { Box } from '@propertypal/web-ui/src/layout';
import PageWrapper from '@propertypal/web-ui/src/layout/PageWrapper';
import { Content } from '@propertypal/web-ui/src/layout/PageWrapper.style';
import { LinkText, SubHeading, Text } from '@propertypal/web-ui/src/typography';
import styled from 'styled-components';

export const Container = styled(PageWrapper)`
  ${Content} {
    max-width: 1080px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 75px;
  padding: 100px 0;

  @media (${laptopMediumMax}) {
    gap: 45px;
  }

  @media screen and (${tabletMax}) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

export const ContentWrapper = styled.div`
  ${SubHeading} {
    line-height: 1.1;

    @media (max-width: 1080px) {
      font-size: 45px;
    }

    @media (${laptopMediumMax}) {
      font-size: 35px;
    }

    @media screen and (${tabletMax}) {
      font-size: 50px;
    }

    @media (${mobileLargeMax}) {
      font-size: 35px;
    }

    @media screen and (min-width: 769px) {
      margin-top: 40px;
    }
  }
  @media screen and (${tabletMax}) {
    text-align: center;

    ${Text} {
      margin: 0 auto;
    }
  }
  ${LinkText} {
    display: inline-flex;
    align-items: center;
    gap: 5px;

    svg {
      font-size: 16px;
    }
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 40px 45px;
  border-radius: 8px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  width: 100%;

  @media screen and (${tabletMax}) {
    padding: 30px 20px;
    max-width: 490px;
  }
  @media screen and (min-width: 769px) {
    flex-basis: 680px;
  }
`;

export const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const InputWrapper = styled.div`
  width: 100%;
`;

export const SentContainer = styled(Box)`
  margin: 80px auto;
  @media screen and (${tabletMax}) {
    margin: 40px 0;
  }
`;
